<template>
  <div>
    <v-row dense>
      <v-col cols="12">
        <ExhibitDropDown />
      </v-col>
    </v-row>
    <v-row
      v-if="selectedSurveyNumberForExhibits != -1"
      dense
      class="exhibit-height"
    >
      <v-col :cols="columns">
        <SurveyExhibits />
      </v-col>
      <v-col :cols="columns">
        <ExhibitsList />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SurveyExhibits from "@/components/Dashboard/Exhibits/SurveyExhibits";
import ExhibitDropDown from "@/components/Dashboard/Exhibits/ExhibitDropDown";
import ExhibitsList from "@/components/Dashboard/Exhibits/ExhibitsList";
import { mapState } from 'vuex'

export default {
  components: {
    SurveyExhibits,
    ExhibitDropDown,
    ExhibitsList
  },
  computed: {
    ...mapState("survey", ["selectedSurveyNumberForExhibits"]),
    columns() {
      return this.$vuetify.breakpoint.xs ? 12 : 6
    }
  },
};
</script>

<style>
.exhibit-height {
  height: 65vh !important;
}
</style>